import { useEffect, useRef, useState } from 'react';
import { PORTAL_NAME } from '../constants/';
import { useLocation } from 'react-router-dom';


const useDocumentTitle = ({ title }: { title: string }) => {  
  const formattedTitle = title.replace(/\b\w/g, char => char.toUpperCase());

  const location = useLocation();

  const newTitle = `${PORTAL_NAME} - ${formattedTitle}`;
  const [pageTitle, setPageTitle] = useState(newTitle)

  const defaultTitle = useRef(document.title);

  useEffect(() => {
    if(defaultTitle.current !== newTitle) {
      const titleId = setTimeout(() => {
        handleSetPageTitle(newTitle)
      }, 1000
    )
    return () => clearTimeout(titleId)
    }

  }, [title, newTitle, location.pathname])

  const handleSetPageTitle = (title: string) => {
    setPageTitle(title);
    document.title = title
  }

  return {
    pageTitle,
    updateTitle: handleSetPageTitle,
    defaultTitle: defaultTitle.current
  }

}

export default useDocumentTitle;